import React from "react";
import { OrgPlotCard as PlotCardWebComponent } from "react-library";
import { TPlot } from "stencil-library";
import { TDefaultProps } from "../../../types";
import { useRecoilValue } from "recoil";
import { languageAtom } from "../../../state/atoms/language.atom";
import { getAccessToken } from "../../../services/common.service";

type TProps =  TDefaultProps & {
  plot: TPlot,
  onPlotSelect?: (plot: TPlot) => void;
}

const PlotCard: React.FC<TProps> = (props) => {
  const { plot, onPlotSelect } = props;

  const selectedLanguage = useRecoilValue(languageAtom);
  const token = getAccessToken();

  const handlePlotSelect = () => {
    try {
      if(onPlotSelect)
        onPlotSelect(plot);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div onClick={handlePlotSelect}>
      <PlotCardWebComponent token={token} language={selectedLanguage ?? "en"} plot={plot} />
    </div>
  );
};

export default PlotCard;